import st from "./ButtonMore.module.scss";

const ButtonMore = () => {
  return <button className={st.button_more}>더보기</button>;
};

export default ButtonMore;
